import * as React from 'react';
import { REGISTRATION_PERMISSION, RegistrationPermission } from '../Registration';
import { useState } from 'react';
import { Button } from '../../../components/Button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faGraduationCap, faShieldAlt, faUserFriends } from '@fortawesome/free-solid-svg-icons';

interface Props {
  permission: RegistrationPermission;
  onPermissionClick: (permission: RegistrationPermission) => void;
}

export function RegistrationPermissionSelector(props: Props) {
  const { permission, onPermissionClick } = props;

  const [currentPermission, changePermission] = useState(permission);
  const isCurrentPermissionExist = typeof currentPermission !== 'undefined';
  const options = [
    {
      id: 'staff',
      value: REGISTRATION_PERMISSION.STAFF,
      title: "I'm a member of staff",
      text: 'Within my school or association.',
      icon: faShieldAlt
    },
    {
      id: 'parent',
      value: REGISTRATION_PERMISSION.PARENT,
      title: "I'm a parent or guardian",
      text: 'Following my children at their school.',
      icon: faUserFriends
    },
    {
      id: 'student',
      value: REGISTRATION_PERMISSION.STUDENT,
      title: "I'm a student",
      text: 'A pupil at my school.',
      icon: faGraduationCap
    }
  ];

  return (
    <div className="eRoleSelect">
      <div className="eSchoolSignupScreenHeader">
        <h1>How will you use Squad In Touch?</h1>
        <p>
          Pick one now. You can request the others later — plenty of people are staff at one school and a parent at
          another.
        </p>
      </div>

      <div className="eRoleCards">
        {options.map(option => {
          const checked = currentPermission === option.value;
          return (
            <button
              key={option.id}
              type="button"
              className={`eRoleCard ${checked ? 'isSelected' : ''}`}
              aria-pressed={checked}
              onClick={() => changePermission(option.value)}
            >
              <span className="eRoleCardIcon">
                <FontAwesomeIcon icon={option.icon} />
              </span>
              <span className="eRoleCardContent">
                <strong>{option.title}</strong>
                <small>{option.text}</small>
              </span>
              <span className="eRoleCardDot" aria-hidden="true">
                <span />
              </span>
            </button>
          );
        })}
      </div>

      <div className="eRegistrationRoleActions">
        <Button
          disabled={!isCurrentPermissionExist}
          onClick={() => {
            onPermissionClick(currentPermission);
          }}
          text={['Continue', <FontAwesomeIcon key="arrow" icon={faArrowRight} />]}
          customClass="eRegistrationSubmitButton"
        />
      </div>
    </div>
  );
}
